'use client';

import { JSX, PropsWithChildren } from 'react';

import { TooltipProvider } from '@videoblocks/design-system';

export function Providers({ children }: PropsWithChildren): JSX.Element {
    return <TooltipProvider>{children}</TooltipProvider>;
}
